import {Map} from 'immutable';

let __lastID__ = Date.now();
const { isMap } = Map;


/**
 * Check if obj is type of state (Immutable)
 * @param obj {*}
 * @returns {boolean}
 */
export const isStateType = obj => isMap(obj);

/**
 * Create state (Immutable map)
 * @param [obj] {object}
 * @returns {Map}
 */
export const createState = (obj = {}) => Map(obj);

/**
 * Create unique ID
 * @returns {number}
 */
export const createUniqueID = () => (__lastID__ += 1);